/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, times: NonNullable<unknown>, minutes: NonNullable<unknown> }} Irrigation_Schedule_Summary_FixedInputs */

const vi_irrigation_schedule_summary_fixed = /** @type {(inputs: Irrigation_Schedule_Summary_FixedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}, lúc ${i?.times}, mỗi lần ${i?.minutes} phút`)
};

/**

* @param {Irrigation_Schedule_Summary_FixedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_summary_fixed = /** @type {((inputs: Irrigation_Schedule_Summary_FixedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Summary_FixedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_summary_fixed(inputs)
});